export default {
  LIVE: 'L',
  CANCELLED: 'C',
  DISABLED: 'D'
}
